import React from 'react';
import PropTypes from 'prop-types';

import SimpleHeader from '../../main/headers/simpleHeader';

const NoOfferView = ({ onLearnMoreClicked }) => (
  <div>
    <SimpleHeader heading="Financing through Stripe Capital" />
    <div className="c-inner-wrapper c-loans-no-offer">
      <div className="u-max-width-620">
        <div className="c-heading c-heading--dark u-fontsize-large u-type--semibold">
          Unlock new possibilities with SQUIRE
        </div>
        <div className="c-loans-no-offer--text">
          We know that growth requires investment, so take your business to the next level!
          Squire partners with Stripe for secure financial services.
          Connect financial data to improve future eligibility for capital.
        </div>
        <button
          className="c-btn c-btn--medium c-loans-no-offer--button"
          type="button"
          onClick={onLearnMoreClicked}
          data-automation-id="loans-no-offer-details-button"
        >
          Learn more
        </button>
        <div className="c-loans-no-offer--disclaimer">
          Clicking “Learn More” will bring you to a third-party website, owned and operated by Stripe, Inc.
          By proceeding you acknowledge and agree to Squire’s Partner Offer disclaimer within the
          Enterprise Terms of Service.
        </div>
      </div>
    </div>
    <div className="u-fontsize-extrasmall u-m">
      Capital Loans are through Celtic Bank. Capital Merchant Cash Advances are through YouLend. All offers subject to
      credit approval.
    </div>
  </div>
);

NoOfferView.propTypes = {
  onLearnMoreClicked: PropTypes.func.isRequired,
};

export default NoOfferView;
